import {
  FETCH_LOGIN_LOGS_REQUEST,
  FETCH_LOGIN_LOGS_SUCCESS,
  FETCH_LOGIN_LOGS_FAILURE
} from '../../../../types/masters/users/loginLog/loginLogTypes';

const initialState = {
  list: [],
  loading: false,
  error: null
};

export default function loginLogReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_LOGIN_LOGS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_LOGIN_LOGS_SUCCESS:
      return { ...state, loading: false, list: action.payload };
    case FETCH_LOGIN_LOGS_FAILURE:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
} 